import React, { Component } from 'react';
import { FaEye, FaMicrosoft } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

import Paths from 'paths';

class Soundbox extends Component{
    render() {
        return (
            <div className={'soundbox-grid-bar'}>
                <div className={'soundbox-grid-bar-id'}>
                    <span>{this.props.soundbox.id}</span>
                </div>
                <div className={'soundbox-grid-bar-title'}>
                    <span>{this.props.title}</span>
                </div>
                <div className={'soundbox-grid-bar-count'}>
                    <span>{this.props.soundbox.sounds.length}</span>
                </div>
                <NavLink className={'soundbox-grid-bar-rendered'} to={Paths.PATH_ADMIN_SHOW_SOUNDBOX_RENDERED.replace(':soundboxId', this.props.soundbox.id)}><FaMicrosoft /></NavLink>
                <NavLink className={'soundbox-grid-bar-see'} to={Paths.PATH_ADMIN_SHOW_SOUNDBOX.replace(':soundboxId', this.props.soundbox.id)}><FaEye /></NavLink>
            </div>
        )
    }
}

export default Soundbox;